import React from "react";
import Icon_Error from "../../assets/Icon_Error.svg";

const PermissionsErrorFallback: React.FC = () => {
  return (
    <div className="ErrorPage PermissionsError">
      <div className="ErrorCell">
        <div className="Img">
          <img src={Icon_Error} alt="Error" />
        </div>
        <div className="Txt">
          <h1>Access unavailable</h1>
          <p>
            It looks like you don't have permission to access this page. Please
            contact an administrator for assistance.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PermissionsErrorFallback;
